export default "__VITE_ASSET__Btk$FJxh__"